import { type RefObject, useEffect, useState } from 'react'

export const isRefSticky = (ref: RefObject<HTMLElement>, threshold: number) => {
	const [isStuck, setIsStuck] = useState(false)
	useEffect(() => {
		const handleScroll = () => {
			if (ref.current) {
				const rect = ref.current.getBoundingClientRect()
				setIsStuck(rect.top === threshold)
			}
		}

		window.addEventListener('scroll', handleScroll)
		return () => window.removeEventListener('scroll', handleScroll)
	}, [ref.current, threshold])

	return isStuck
}
